import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { Router, Route, Switch } from 'react-router-dom'
import history from '../common/history'
import Winlist from './component/winlist'
import View from './component/view'
import Reducer from './libs/reducer'

const store = createStore(Reducer)
ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Switch>
                <Route path="/win/view/:idx_cat_evt" component={View} />
                <Route path="/win/detail/:idx_cat_evt" component={View} />
                <Route path="/win/" component={Winlist} />
                <Route path="/win/:page" component={Winlist} />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById('happy_shopping_event'),
)
